import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import HomePageTemplate from '../components/HomePageTemplate'

const HomePage = ({ data }) => {
  const { frontmatter } = data.markdownRemark

  return (
      <HomePageTemplate
        title={frontmatter.title}
        welcomeMessage={frontmatter.welcomeMessage}
        welcomeAside={frontmatter.welcomeAside}
        nineEleven={data.nineEleven}
      />
  )
}

HomePage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    })
  }),
}

export default HomePage

export const homePageQuery = graphql`
  query HomePage($id: String!) {
    nineEleven: file(relativePath: {eq: "In honor of 9.11.2001-Westlake.jpg"}) {
      publicURL
      childImageSharp {
        fluid (maxWidth: 2048) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        welcomeMessage
        welcomeAside {
          childImageSharp {
            fixed (width: 500, height: 1000, cropFocus: ENTROPY) {
              ...GatsbyImageSharpFixed
            }
          }
        }
      }
    }
  }
`